import React from "react";
import styles from "./Table.module.scss";
import ArrowIcon from "../../assets/svg/icons/common/arrow";
import useCommonStore from "../../stores/common";
import useDomainStore from "../../stores/domain";
import SkeletonRow from "../skeleton-loader/table/row";
import rowsToFill from "../../utils/rows-to-fill";

const Table = ({
  layout = "auto",
  columns,
  data,
  sortBy,
  sortColumn,
  onSortClick,
  onRowClick,
  renderExpandedContent,
  expandedContentClassName = "",
  selectedRowId = null,
  searching = false,
  className = "",
  disablePaddingOnExpandedRow = false,
  enableSkeleton = false,
  dataLoading = false,
  noMarginTop = false,
  emptyMessage = "No data to display",
}) => {
  const { isKurvDomain } = useDomainStore();
  const showDetails = useCommonStore((state) => state.showDetails);
  const visibleColumns = columns.filter((col) => !col?.hideCell);

  return (
    <div
      className={`${styles.tableContainer} ${layout === "fixed" ? `${styles.fixed} ${showDetails ? styles.detailsVisible : ""}` : ""} ${className}`}
    >
      <table
        className={`${styles.table} ${noMarginTop ? styles.noMarginTop : ""} ${isKurvDomain ? styles.kurv_theme : ""}`}
      >
        <thead>
          <tr className={styles.headerRow}>
            {columns
              .filter((col) => !col?.hideCell)
              .map((col) => (
                <th
                  key={col.field}
                  className={styles.headerCell}
                  style={{
                    width: col.width || "auto",
                  }}
                >
                  {col.allowSort ? (
                    <button onClick={() => onSortClick(col.field)}>
                      <span>
                        {col.renderHeader ? col.renderHeader() : col.headerName}
                      </span>
                      <div className={sortColumn === "DESC" ? styles.down : ""}>
                        {sortBy === col.field && <ArrowIcon />}
                      </div>
                    </button>
                  ) : (
                    <>
                      {col.renderHeader ? col.renderHeader() : col.headerName}
                    </>
                  )}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {enableSkeleton &&
            dataLoading &&
            Array.from({ length: rowsToFill(window.innerHeight, 64) }).map(
              (_, index) => (
                <SkeletonRow key={index} columnLength={visibleColumns.length} />
              ),
            )}

          {!dataLoading && !data?.length && (
            <tr>
              <td colSpan={visibleColumns.length}>
                <div className={styles.noData}>
                  <span>{emptyMessage}</span>
                </div>
              </td>
            </tr>
          )}

          {!dataLoading &&
            data?.length > 0 &&
            data.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  className={`${styles.row} ${row.expanded ? styles.expanded : ""} ${selectedRowId === row.id ? styles.selectedRow : ""}`}
                  onClick={() => onRowClick?.(row)}
                >
                  {visibleColumns.map((col, idx) => (
                    <td
                      key={col.field}
                      className={`${styles.cell} ${col.overflow ? styles.overflow : ""}`}
                      style={{
                        width: col.width || "auto",
                        maxWidth: col.maxWidth ? col.maxWidth : "auto",
                      }}
                    >
                      {col.renderCell
                        ? col.renderCell(row[col.field], row)
                        : row[col.field]}

                      {idx === 0 && selectedRowId === row.id && (
                        <span className={styles.selected} />
                      )}
                    </td>
                  ))}
                </tr>

                {row.expanded && renderExpandedContent && (
                  <tr className={styles.expandedRow}>
                    <td
                      colSpan={visibleColumns.length}
                      className={
                        disablePaddingOnExpandedRow
                          ? styles.disablePaddingOnExpandedRow
                          : ""
                      }
                    >
                      <div
                        className={`${styles.expandedContent} ${expandedContentClassName}`}
                      >
                        {renderExpandedContent(row)}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
